import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { Logger } from '../../../../common/utils/logger';
import { getSetCookieOverride } from '../set-cookie-override';

// Hijack the document.cookie setter logic so we can track cookie and usage info if we've opted into cookies management
// This will generate a passthrough that will call the original document.cookie setter logic after we've logged analytics
export var createDocumentCookiePassthrough = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var documentCookieProperty, originalSetter, originalGetter;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          documentCookieProperty = Object.getOwnPropertyDescriptor(Document.prototype, 'cookie');
          originalSetter = documentCookieProperty === null || documentCookieProperty === void 0 ? void 0 : documentCookieProperty.set;
          originalGetter = documentCookieProperty === null || documentCookieProperty === void 0 ? void 0 : documentCookieProperty.get;
          if (!(!originalSetter || !originalGetter)) {
            _context.next = 6;
            break;
          }
          Logger.warn('No document.cookie capabilities found');
          return _context.abrupt("return");
        case 6:
          // Override document.cookie setter
          Object.defineProperty(document, 'cookie', {
            get: originalGetter,
            set: getSetCookieOverride(originalSetter),
            configurable: true
          });
        case 7:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function createDocumentCookiePassthrough() {
    return _ref.apply(this, arguments);
  };
}();